export function getScoreString(score) {
    if (score >= 1000000) {
        var symbols = { Y: 24, Z: 21, E: 18, P: 15, T: 12, G: 9, M: 6 };
        for (var sym in symbols) {
            if (symbols.hasOwnProperty(sym)) {
                var power = symbols[sym];
                var factor = Math.pow(10, power);
                if (score >= factor) {
                    var num = score / factor;
                    var ln = num.toFixed(0).length;
                    return num.toFixed(Math.max(0, 5 - ln)) + sym;
                }
            }
        }
    }
    return String(score);
}
